var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3994 0C34.7698 0.000243137 44.7978 10.0289 44.7979 22.3994C44.7977 34.7698 34.7697 44.7976 22.3994 44.7979C10.0289 44.7979 0.000179244 34.7699 0 22.3994C5.10771e-06 10.0288 10.0288 0 22.3994 0ZM22.3984 2.98633C11.6776 2.98663 2.98659 11.6776 2.98633 22.3984C2.98633 32.952 11.408 41.5387 21.8975 41.8047L22.3984 41.8115C32.9523 41.8115 41.5392 33.3893 41.8047 22.8994L41.8115 22.3984C41.8113 11.6775 33.1195 2.98636 22.3984 2.98633ZM21.2051 17.3418C18.9109 17.8813 17.2024 19.9396 17.2021 22.3984C17.2021 24.8574 18.9109 26.9154 21.2051 27.4551V39.3789C12.3605 38.7661 5.37598 31.3987 5.37598 22.3984C5.37623 13.3984 12.3607 6.03073 21.2051 5.41797V17.3418ZM23.5938 5.41797C32.4376 6.03134 39.4216 13.3988 39.4219 22.3984C39.4219 31.3983 32.4377 38.7654 23.5938 39.3789V27.4551C25.8876 26.9151 27.5957 24.8571 27.5957 22.3984C27.5955 19.9399 25.8875 17.8816 23.5938 17.3418V5.41797Z",
    fill: "#33A444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileHeaderLogo);
export default __webpack_public_path__ + "static/media/mobile-header-logo.0ec6fdf51ad31a3dbe357f672cf86b5c.svg";
export { ForwardRef as ReactComponent };